// Dependencies
import { createGlobalStyle } from 'styled-components';

const TableStyles = createGlobalStyle`
  table {
    width: 100%;
    margin: 0 auto;
    border: 0.063rem solid var(--color-swiss-coffee);
    border-collapse: collapse;
    text-align: left;

    th {
      background-color: var(--color-graphite);
      color: var(--color-white);
    }

    th,
    td {
      padding: 0.5rem;
      border: 1px solid #ddd;
    }

    td {
      color: var(--color-charcoal);
    }
  }
`;

export default TableStyles;
